export default __webpack_public_path__ + "static/media/features_gas_station.8faf019f.png";